import * as CONSTANTS from './OrderActionConstants'
import { APIDirectory, HTTP } from "../../rest"
export const getOrderHistoryBySchoolIdInProgress = () => {
    return {
        type: CONSTANTS.FETCH_ORDER_HISTORY_IN_PROGRESS
    };
};

export const getOrderHistoryBySchoolIdComplete = data => {
    return {
        type: CONSTANTS.FETCH_ORDER_HISTORY_COMPLETE,
        data: data
    };
};
export const getOrderHistoryBySchoolIdFailed = data => {
    return {
        type: CONSTANTS.FETCH_ORDER_HISTORY_FAILED,
        data: data
    };
};

export const getOrderHistoryBySchoolId = (schoolId) => {
    return async dispatch => {
        try {
            dispatch(getOrderHistoryBySchoolIdInProgress());
            let url = APIDirectory.getOrderHistoryBySchoolIdURL(schoolId);
           let orderHistory = await HTTP.GET(url);
            dispatch(getOrderHistoryBySchoolIdComplete(orderHistory));
            return orderHistory
        }
        catch (error) {
            dispatch(getOrderHistoryBySchoolIdFailed(error));
            return [];
        }
    };
};